// extracted by mini-css-extract-plugin
export default {"footer_web_nav_logo_img":"footer_footer_web_nav_logo_img__2tgP3","footer_web_wrapper":"footer_footer_web_wrapper__cQd-J"};